/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Permissions_TitleInputs */

const es_components_credentials_permissions_title = /** @type {(inputs: Components_Credentials_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos de la credencial`)
};

const en_components_credentials_permissions_title = /** @type {(inputs: Components_Credentials_Permissions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credential permissions`)
};

/**
* | output |
* | --- |
* | "Credential permissions" |
*
* @param {Components_Credentials_Permissions_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_permissions_title = /** @type {((inputs?: Components_Credentials_Permissions_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Permissions_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_permissions_title(inputs)
	return en_components_credentials_permissions_title(inputs)
});
export { components_credentials_permissions_title as "components.credentials.permissions.title" }